import { useContext, useEffect, useState } from "react";
import AuthContext from "../store/authContext";
import AXIOS from "../components/helpers/axios"
import axios from "axios";
import { errorNotify, successNotify } from "../components/ui/alerts/toast/toastUtils";

function useApi() {
    const authCtx = useContext(AuthContext);
    const API_URL = process.env.REACT_APP_API_URL;
    const LOGIN_HEADERS = JSON.parse(process.env.REACT_APP_API_HEADERS_FORM)
    const HEADERS = JSON.parse(process.env.REACT_APP_API_HEADERS);

    if (authCtx.token !== undefined) {
        HEADERS["Authorization"] = `Bearer ${authCtx.token}`;
    }

    const [data, setData] = useState(null);
    const [apiStatus, setAPIStatus] = useState({
        isLoading: false,
        isLoaded: false,
        error: null,
    });

    const fetchData = async (url, params) => {
        if (params === undefined) {
            params = null;
        }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));

        try {
            // Construct URL with query parameters
            const queryParams = new URLSearchParams(params).toString();
            const URL = `${API_URL}${url}${params ? `?${queryParams}` : ""}`;

            const headers = HEADERS;

            const response = await fetch(URL, {
                method: "GET",
                headers: headers,
            });

            const data = await response.json();

            if (data.error) {
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data,
                }));
            } else {
                setData(data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error,
            }));
        }
    };

    const login = async (url, body) => {
        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            const res = await AXIOS.post(url, body, {
                headers: { "Content-Type": "application/json" },
            });
            if (res.data) {
                setData(res.data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            } else {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: res.message,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error.response.data.error,
            }));
        }
    };

    const postData = async (url, body, successMessage, errorMessage) => {
        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            const formData = new FormData();
            Object.keys(body).forEach((key) => {
                formData.append(key, body[key]);
            });

            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            const data = response?.data;
            if (data.status === false) {
                console.log('response', data);
                if (data?.data?.error) {
                    if (typeof data.data.error === "object") {
                        errorNotify(errorMessage !== undefined ? errorMessage : data?.data?.error?.message);
                    } else if (typeof data.data.error === "array") {
                        data.data.error.forEach((error) => {
                            errorNotify(error.message)
                        })
                    } else {
                        errorNotify(data.data.error)
                    }
                }
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data.data.error,
                }));
            } else {
                successNotify(successMessage !== undefined ? successMessage : data?.data?.message);
                setData(data?.data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            errorNotify(error?.response?.data?.error?.message);
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error?.response?.data?.error,
            }));
        }
    };

    const putData = async (url, body, successMessage) => {
        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            const URL = `${API_URL}${url}`;

            const headers = HEADERS;

            const response = await fetch(URL, {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(body),
            });

            const data = await response.json();

            if (data.error) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data,
                }));
            } else {
                setData("success");
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error,
            }));
        }
    };

    const deleteData = async (url, successMessage) => {
        setData(null);
        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        try {
            const URL = `${API_URL}${url}`;

            const headers = HEADERS;

            const response = await fetch(URL, {
                method: "DELETE",
                headers: headers,
            });

            const data = await response.json();

            if (data.error) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: true,
                    isLoaded: false,
                    error: data,
                }));
            } else {
                setData("success");
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: true,
                isLoaded: false,
                error: error,
            }));
        }
    };

    return {
        data,
        apiStatus,
        fetchData,
        login,
        postData,
        putData,
        deleteData,
    };
}

export default useApi;
